import CoursesAdministrationTabsView from '@src/components/course/view/CoursesAdministrationTabsView';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

const CourseListAdministrationPage = (props: WithRouterProps) => <CoursesAdministrationTabsView openedTab={props.params.openedTab} />;

export default withRouter(CourseListAdministrationPage);
